import { selectedTasksData } from '@dyl/apiClients/backendApi';
import { useCallback } from 'react';
import useTasksDownload from './useTasksDownload';

export default function useExport() {
    const download = useTasksDownload();

    return useCallback(
        /**
         * @param {string[]} selectedIds
         */
        async function exportTasks(selectedIds) {
            let tasksToExport = {};
            let tasksToExportA2 = [];

            if (selectedIds.length > 0) {
                tasksToExport = await selectedTasksData(selectedIds);
            }

            if (tasksToExport[0].level_id === '200f307f-415d-4bbc-9051-1568d16f96b8') {
                for (const task of tasksToExport) {
                    tasksToExportA2.push({
                        ...task,
                        arc_status:
                            task.is_arc_published === true ? 'Sent'
                            : task.is_arc_published === false ? 'Draft'
                            : ''
                    });
                }
            }
            const toExport = tasksToExport[0].level_id === '200f307f-415d-4bbc-9051-1568d16f96b8' ? tasksToExportA2 : tasksToExport;

            await download(toExport);

        }, [download]
    );
}